export default "__VITE_ASSET__d98807d2__"